// @ts-nocheck
import { getAccountState } from "@insite/client-framework/Store/Data/Accounts/AccountsSelector";
import loadAccount from "@insite/client-framework/Store/Data/Accounts/Handlers/LoadAccount";
import {
    chain,
    DispatchLoadAccountIfNeeded,
} from "@insite/client-framework/Store/Pages/UserSetup/Handlers/DisplayUser";
import { makeHandlerChainAwaitable, replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";
// The userList page is overwriting custom properties on the account so we need to reload the account on every user setup page load.
replaceInChain(chain, DispatchLoadAccountIfNeeded, async props => {
    const { dispatch, getState, parameter } = props;
    const awaitableLoadAccount = makeHandlerChainAwaitable(loadAccount as any);
    await awaitableLoadAccount({ accountId: parameter.userId })(dispatch, getState);
});
